import { ProbeEventStatus } from '@/modules/stats/availability/domain/probe-event/status/probe-event-status.js';

export class AvailableStatus extends ProbeEventStatus {
  getTranslateTextKey() {
    return 'stats.availability.status.available';
  }

  getBackgroundColor() {
    return 'bg-success';
  }

  getTextColor() {
    return 'text-success';
  }

  getOutlineColor() {
    return 'outline-success';
  }
}
